import React, { useContext, useEffect, useState } from "react";
import "./Projects.css";
import ModuleSidebar from "../../components/ModuleSidebar/ModuleSidebar";
import { GoPeople } from "react-icons/go";
import { GiSettingsKnobs } from "react-icons/gi";
import { GrProjects } from "react-icons/gr";
import { useLanguage } from "../../LanguageProvider";
import InviteProject from "./components/InviteProject/InviteProject";
import ProjectAuthorization from "./components/ProjectAuthorization/ProjectAuthorization";
import { GeneralContext } from "../../GeneralProvider";
import RenameProject from "./components/RenameProject/RenameProject";
import DeleteProject from "./components/DeleteProject/DeleteProject";
import SentInvites from "./components/ProjectAuthorization/components/SentInvites";
import ProjectList from "./components/ProjectList/ProjectList";

export default function Projects() {
  const { getTranslation } = useLanguage();
  const {
    selectedProjectTitle,
    selectedProjectID,
    collaborators,
    userId,
    users,
    fetchMembers,
    handleGetSentProjectInvitations,
  } = useContext(GeneralContext);
  const [selectedSubmenu, setSelectedSubmenu] = useState(
    getTranslation("manageCollaborators")
  );
  const [selectedSubmenuId, setSelectedSubmenuId] = useState(1);

  useEffect(() => {
    fetchMembers();
    handleGetSentProjectInvitations();
  }, [selectedProjectID]);

  const menus = [
    {
      sections: [
        {
          title: getTranslation("projects"),
          icon: <GrProjects size={20} />,
          submenu: [{ title: getTranslation("projectList"), id: 6 }],
        },
        {
          title: getTranslation("collaborators"),
          icon: <GoPeople size={20} />,
          submenu: [
            { title: getTranslation("manageCollaborators"), id: 1 },
            { title: getTranslation("authorization"), id: 2 },
            { title: getTranslation("sentInvitations"), id: 3 },
          ],
        },
        {
          title: getTranslation("settings"),
          icon: <GiSettingsKnobs size={20} />,
          submenu: [
            { title: getTranslation("rename"), id: 4 },
            { title: getTranslation("delete"), id: 5 },
          ],
        },
      ],
    },
  ];

  const handleSubmenuClick = (submenu) => {
    // id verilmeli
    fetchMembers();
    handleGetSentProjectInvitations();
    setSelectedSubmenuId(submenu.id);
    setSelectedSubmenu(submenu.title);
  };

  return (
    <div className="projects-container">
      <ModuleSidebar
        title={selectedProjectTitle || getTranslation("workSpaceManager")}
        menus={menus}
        selectedSubmenu={selectedSubmenuId}
        onSubmenuClick={handleSubmenuClick}
      />
      <div className="projects-content">
        <div className="projects-inner-content">
          {selectedSubmenu === getTranslation("projectList") && (
            <ProjectList selectedProjectID={selectedProjectID} />
          )}
          {selectedSubmenu === getTranslation("manageCollaborators") && (
            <InviteProject
              collaborators={collaborators}
              selectedProjectID={selectedProjectID}
            />
          )}
          {selectedSubmenu === getTranslation("authorization") && (
            <ProjectAuthorization
              users={users?.filter((user) => user?.userID !== userId)}
            />
          )}

          {selectedSubmenu === getTranslation("rename") && <RenameProject />}

          {selectedSubmenu === getTranslation("delete") && <DeleteProject />}

          {selectedSubmenu === getTranslation("sentInvitations") && (
            <SentInvites />
          )}
        </div>
      </div>
    </div>
  );
}
